import { theme } from '@agilize/components-core';
import { device } from '@styles/tools/breakpoints.styles';
import styled, { css } from 'styled-components';

export const trumpsUtilities = () => css`
  .centered-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    &__full {
      flex: 1;
    }
  }

  .hide-mobile {
    ${device.mobile} {
      display: none;
    }
  }

  .hide-not-mobile {
    display: none;
    ${device.mobile} {
      display: block;
    }
  }

  .hide-not-desktop {
    display: none;
    ${device.desktop} {
      display: block;
    }
  }

  .buttons-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding-top: ${props => props.theme.global.gutterSpace * 1.25}px;

    button,
    a {
      margin-right: ${props => props.theme.global.gutterSpace}px;

      &:last-child {
        margin-right: 0;
      }
    }

    &--right {
      justify-content: flex-end;
    }
  }

  .default-font {
    font-family: ${theme.global.defaultFont};
  }

  .secondary-font {
    font-family: ${theme.global.secondaryFont};
  }

  .agilize-table__thead,
  .agilize-table__tbody {
    .table-col {
      &--5 {
        width: 5%;
      }
      &--10 {
        width: 10%;
      }
      &--15 {
        width: 15%;
      }
      &--20 {
        width: 20%;
      }
      &--25 {
        width: 25%;
      }
      &--35 {
        width: 35%;
      }
      &--40 {
        width: 40%;
      }
      &--45 {
        width: 45%;
      }
      &--50 {
        width: 50%;
      }
      &-align {
        &--right {
          text-align: right;
        }
        &--left {
          text-align: left;
        }
        &--center {
          text-align: center;
        }
      }
    }
  }

  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  a.default-text-size {
    font-size: 1.6rem !important;
  }
`;

export const Hidden = styled.div`
  display: none;
`;

export const headerHeightDesktop = '70px';
export const headerHeightMobile = '54px';
